import React from 'react';
import { useHistory } from 'react-router-dom';
import cogoToast from 'cogo-toast';
import { Button, Card, CardBody, CardHeader, Container } from 'reactstrap';
import BreadcrumbTrail from '../../../../../../Common/BreadcrumbTrail';
import carSvg from '../../../../../../../assets/images/car.svg';

const SelectBenefit = ({ state, setState, setFormCount }) => {
  const history = useHistory();

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    }
  };

  const handleSubmit = () => {
    cogoToast.error('Please select benefit first');
    return;
  };

  const routeHandler = () => {
    setFormCount(2);
  };

  return (
    <div className="page-content">
      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={`Vendor Onboarding`}
              navigationby={breadcrumNavigationHandler}
              navigation={['Management', 'Inventory', 'Onboarding', 'Select Benefit']}
            />
          </div>
        </div>

        <Card>
          <CardHeader>
            <h5 className="m-0 fw-semibold">Select your Benefit</h5>
          </CardHeader>
          <CardBody className="pb-5">
            <div className="scrollable-1 mt-3">
              <div className="d-inline-flex gap-4">
                <div className="card card-6 " onClick={() => routeHandler()}>
                  <div className="d-flex justify-content-between sla-card cursor-pointer align-items-center">
                    <img src={carSvg} className="img-fluid" alt="" style={{ maxWidth: '45px', height: '45px' }} />
                    <p className="text-black text-format-7 m-0">Airport Transfer</p>
                  </div>
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
        <div className="d-flex justify-content-end">
          <Button className="overlay-disable" style={{ width: '130px' }} color="primary" onClick={handleSubmit}>
            Continue
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default SelectBenefit;
